const fixtureItems = [
  {
    id: 1,
    image: "/assets/images/Capture d’écran 2024-01-08 à 15.34.22.png",
    name: "Plot Dakota réglable de 18 à 36mm",
  },
  {
    id: 2,
    image: "/assets/images/Capture d’écran 2024-01-08 à 15.37.40.png",
    name: "Plot Dakota réglable de 35 à 60mm",
  },
  {
    id: 3,
    image: "/assets/images/Capture d’écran 2024-01-04 à 19.03.33.png",
    name: "Plot Dakota réglable de 60 à 115mm",
  },
  {
    id: 4,
    image: "/assets/images/Capture d’écran 2024-01-04 à 19.11.16.png",
    name: "Pose sur cale d'isolation 10mm",
  },
  {
    id: 5,
    image: "/assets/images/Screenshot 2023-12-16 at 18.14.52.png",
    name: "Lambourde Pin traité classe 4",
  },
  {
    id: 6,
    image: "/assets/images/4381249 copy 2.png",
    name: "J'ai déja ma structure",
  },
];


const fixtureSystem = [
  {
    imageUrl: '/assets/images/Screenshot 2023-12-16 at 18.19.17 Copy.png',
    label: 'Vis Inox A2 - 5x60',
    showCheckbox: true,
  },
  {
    imageUrl: '/assets/images/Screenshot 2023-12-16 at 18.19.17 Copy.png',
    label: 'Vis Inox Marin A4 - 5X60',
    showCheckbox: true,
  },
  {
    imageUrl: '/assets/images/4381249 copy 2.png',
    label: 'Dalles IPE 500x500x38',
    showCheckbox: true,
  },
]


export {fixtureItems, fixtureSystem};